import React, { FunctionComponent, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  Avatar,
  Theme,
  makeStyles,
  createStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/Home";
import { Link as RouterLink, Redirect, useHistory } from "react-router-dom";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { APP_NAME, AUTH_API, AUTH_AXIOS_OPTIONS } from "../utils/constants";
import Axios from "axios";
import { handleAxiosError, parseJwt } from "../utils/functions";
import { IUsuario } from "../pages/interfaces";
import { Settings } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      width: 70,
      height: 70,
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
  })
);

interface NavbarProps {
  title?: string;
}

const Navbar: FunctionComponent<NavbarProps> = ({ title }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const jwt = localStorage.getItem("jwt");
  const usuario: IUsuario = parseJwt(jwt || "");

  const history = useHistory();

  const logout = async () => {
    const api = `${AUTH_API}/usuarios/logout`;
    try {
      const res = await Axios.post(api, null, AUTH_AXIOS_OPTIONS);
      if (res.status === 200) {
        localStorage.clear();
        history.push("/login");
      }
    } catch (err) {
      const error = err as any;
      await handleAxiosError(error);
    }
  };

  const getIniciales = (nombre: string, paterno: string): string => {
    const nombres = nombre.split(" ");
    return `${nombres[0].substring(0, 1).toUpperCase()}${paterno
      .substring(0, 1)
      .toUpperCase()}`;
  };

  if (!jwt) {
    return <Redirect to="/login" />;
  }
  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            onClick={() => setOpen(true)}
            edge="start"
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6">{title || APP_NAME}</Typography>
        </Toolbar>
      </AppBar>

      <Drawer open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            minWidth: 250,
            display: "flex",
            justifyContent: "center",
            marginTop: 15,
            textAlign: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar className={classes.avatar}>
            {getIniciales(usuario.nombre, usuario.paterno)}
          </Avatar>
          <Typography variant="subtitle1" style={{ marginTop: 10 }}>
            {usuario.nombre} {usuario.paterno} {usuario.materno}
          </Typography>
        </div>
        <List component="nav" style={{ marginTop: 15 }}>
          <ListItem button component={RouterLink} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Inicio" />
          </ListItem>
          <ListItem button component={RouterLink} to="/receipts">
            <ListItemIcon>
              <AccountBalanceWalletIcon />
            </ListItemIcon>
            <ListItemText primary="Comprobantes de pago" />
          </ListItem>
          {/* <ListItem button component={RouterLink} to="/receipts/authentication">
                        <ListItemIcon>
                            <VpnKeyIcon />
                        </ListItemIcon>
                        <ListItemText primary="Autenticidad de mi recibo" />
                    </ListItem> */}
          <Divider />
          <ListItem button component={RouterLink} to="/settings">
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            <ListItemText primary="Ajustes" />
          </ListItem>
          <ListItem button onClick={logout}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesión" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default Navbar;
